module.exports = __webpack_public_path__ + "img/05.58be3716.png";